import { render, staticRenderFns } from "./CompanyEditSidebar.vue?vue&type=template&id=3f297a52&scoped=true&"
import script from "./CompanyEditSidebar.vue?vue&type=script&lang=js&"
export * from "./CompanyEditSidebar.vue?vue&type=script&lang=js&"
import style0 from "./CompanyEditSidebar.vue?vue&type=style&index=0&id=3f297a52&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f297a52",
  null
  
)

export default component.exports